import React from "react";
import "./Style/Style.css";
import car6 from "./Assits/spoken.png";
import { Link } from "react-router-dom";

const spoken = () => {
  return (
    <div>
      <section class="Subject neet_councelling">
        <h2>English Spoken/</h2>
      </section>
      <section class=" more more2">
        <img src={car6} alt="" />
        <p>
          English proficiency is undeniably one of the most sought-after soft
          skills in today's competitive job market. However, many students
          possess the knowledge of English yet struggle to excel due to a lack
          of the right learning environment. That's where we come in. Our
          mission is to create the ideal atmosphere for students to hone their
          spoken English skills and boost their confidence in communication.
        </p>
        <p>
          Our goal is to empower students to break free from the shackles of
          hesitation and perform exceptionally well in their careers. By
          providing them with the platform and support they need, we pave the
          way for their success in the globalized, English-dominated
          professional world. Join us on this journey of linguistic and personal
          growth, and unlock a world of opportunities through effective spoken
          English skills.
        </p>
        <Link to="/services" class="btn">
          <i class="fas fa-arrow-left"></i>Go back
        </Link>
      </section>
    </div>
  );
};

export default spoken;
